export default __webpack_public_path__ + "fonts/bccd2def9ce11808e1bfbaa72c96c37f.svg";